import { makeStyles } from '@mui/styles';
import { GlobalFonts } from '@alycecom/ui';

import 'lato-font/css/lato-font.css';

const useStyles = makeStyles(() => ({
  '@global': {
    ...GlobalFonts,
    '*, *::before, *::after': {
      boxSizing: 'border-box',
    },
    'body, html': {
      height: '100%',
      width: '100%',
      fontFamily: 'effra,Helvetica Neue,Helvetica,Arial,sans-serif',
      fontWeight: 400,
      margin: 0,
    },
    '#alyce-recipient': {
      position: 'relative',
      minHeight: '100%',
      height: '100%',
      zIndex: 1,
    },
  },
}));

const GlobalStyles = () => {
  useStyles();
  return null;
};

export default GlobalStyles;
